module.exports = __webpack_public_path__ + "static/media/nenglifen4.5605af7b.jpg";